export const DESSERTS_ARTICLE = {
  path: "/blog/cambodian-desserts-melbourne",
  title: "Cambodian Desserts in Melbourne: Black Rice Pudding & Mango Sticky Rice | ANGKOR",
  headline: "Cambodian Desserts in Melbourne: Black Rice Pudding, Mango Sticky Rice and Coconut",
  description: "A guide to Cambodian desserts: black rice pudding, sticky rice with mango and coconut ice cream, and where to try them at ANGKOR, 389 Spencer St, West Melbourne.",
  image: "/manus-storage/black-sticky-rice-dessert-angkor_fc5b177d.webp",
  imageSrcSet: "/manus-storage/black-sticky-rice-dessert-angkor-480_75a41e89.webp 480w, /manus-storage/black-sticky-rice-dessert-angkor-800_e28e95ca.webp 800w, /manus-storage/black-sticky-rice-dessert-angkor_fc5b177d.webp 1440w",
  imageAlt: "Black rice pudding with coconut cream at ANGKOR West Melbourne",
  datePublished: "2026-10-21",
  dateLabel: "21 October 2026",
  byline: "By the ANGKOR team",
  excerpt: "A guide to Cambodian desserts: black rice pudding, sticky rice with mango and coconut ice cream, and where to try them at ANGKOR.",
} as const;
